import { View, Text } from "react-native";
import { ArrowLeftRight, MapPin } from "lucide-react-native";
import { useNavigation } from "@react-navigation/native";
import { EMBER } from "../../../onboarding/theme";
import StatusBadge from "../../components/StatusBadge";
import { useRegion, useTranslations } from "@src/packages/i18n";
import { CardSurface, SecondaryButton, semanticColors } from "@louise/moon-ui";
import { withAlpha } from "@louise/theme/tokens";

function PlaceholderClinicRow({ widthPct }: { widthPct: number }) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: 10,
        paddingVertical: 4,
      }}
    >
      <View
        style={{
          width: 36,
          height: 36,
          borderRadius: 8,
          backgroundColor: withAlpha(semanticColors.surface.default, 0.15),
        }}
      />
      <View style={{ flex: 1, gap: 6 }}>
        <View
          style={{
            width: `${widthPct}%`,
            height: 10,
            borderRadius: 4,
            backgroundColor: semanticColors.border.default,
          }}
        />
        <View
          style={{
            width: "40%",
            height: 8,
            borderRadius: 4,
            backgroundColor: semanticColors.border.default,
          }}
        />
      </View>
      <View
        style={{
          width: 50,
          height: 10,
          borderRadius: 4,
          backgroundColor: semanticColors.border.default,
        }}
      />
    </View>
  );
}

export default function CompareClinicCostsCard() {
  const navigation = useNavigation<{
    navigate: (screen: string, params?: object) => void;
  }>();
  const region = useRegion();
  const t = useTranslations();
  const isUS = region === "US";

  if (region === null) return null;

  return (
    <CardSurface style={{ padding: 20 }}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 14,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
          <ArrowLeftRight
            size={18}
            color={EMBER.colors.textLight}
            strokeWidth={1.5}
          />
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 15,
              fontWeight: "600",
              color: EMBER.colors.text,
            }}
          >
            {t("compare_clinic.compare_clinic_costs")}
          </Text>
        </View>
        <StatusBadge type="coming-soon" />
      </View>

      <Text
        className="font-dm-sans"
        style={{
          fontSize: 13,
          color: EMBER.colors.textLight,
          lineHeight: 19,
          marginBottom: 14,
        }}
      >
        {t("compare_clinic.comparison_coming_soon")}
      </Text>

      {/* Placeholder clinic rows */}
      <View
        style={{
          gap: 8,
          opacity: 0.5,
          marginBottom: isUS ? 16 : 0,
        }}
      >
        <PlaceholderClinicRow widthPct={65} />
        <PlaceholderClinicRow widthPct={55} />
        <PlaceholderClinicRow widthPct={70} />
      </View>

      {/* Find Care CTA — US only; FindCare uses US clinic data */}
      {isUS && (
        <SecondaryButton
          label={t("compare_clinic.find_care")}
          action="compare_clinic.find_care"
          leading={
            <MapPin
              size={16}
              color={semanticColors.text.secondary}
              strokeWidth={1.8}
            />
          }
          onPress={() => {
            navigation.navigate("Access", {
              screen: "FindCare",
              params: { returnTab: "Costs" },
            });
          }}
        />
      )}
    </CardSurface>
  );
}
